
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductSequenceDialog extends _Ext.ItemEditorDialog<ProductSequenceRow> {
        protected getFormKey() { return ProductSequenceForm.formKey; }
        protected getIdProperty() { return ProductSequenceRow.idProperty; }
        protected getLocalTextPrefix() { return ProductSequenceRow.localTextPrefix; }
        protected getService() { return ProductSequenceService.baseUrl; }
        protected getDeletePermission() { return ProductSequenceRow.deletePermission; }
        protected getInsertPermission() { return ProductSequenceRow.insertPermission; }
        protected getUpdatePermission() { return ProductSequenceRow.updatePermission; }

        protected form = new ProductSequenceForm(this.idPrefix);

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

    }
}